<template>
  <div class="slide-start-download">
    <bim-text type=h5 bold class="text-center">Начинаем скачивание...</bim-text>
    <bim-text type=main class="slide-start-download__desc text-center mx-auto my-9">Спасибо за использование сервиса.</bim-text>
    <bimButton class="slide-start-download__button mx-auto d-block" @click="$emit('closePopup')" label="Ясно" />
  </div>
</template>

<script>
import bimButton from "@bimlib/components/bimButton"
export default {
  name: "SlideStartDownload",
  components: {
    bimButton,
  },
}
</script>

<style lang="scss" scoped>
.slide-start-download {
  .slide-start-download__desc {
    max-width: 600px;
  }
  .slide-start-download__button {
    height: auto;
    font-size: 18px;
    line-height: 1.44;
    padding: 21px 120px;
  }
}
</style>
